import { CheckDescriptionStatus, SEARCH_FILTER_KEYS } from 'v2/models';

export type excludeDataVendorsFilterValue = {
  data_vendor_id: number;
  data_provider_id: number | null;
  name: string | null;
};

type SearchFilterFormMultiSelect = { name: string };
type SearchFilterFormCheckbox = boolean;
export type SearchFilterFormPairText = { unit: string; value: string | number };
export type ExcludeDataVendorFilterForm = {
  is_all: boolean;
  list: excludeDataVendorsFilterValue[];
};

type SearchFilterArray = (
  | SearchFilterFormMultiSelect
  | SearchFilterFormPairText
)[];

export type SearchFilterForm =
  | SearchFilterFormMultiSelect
  | SearchFilterFormCheckbox
  | SearchFilterFormPairText
  | SearchFilterArray
  | ExcludeDataVendorFilterForm;

export interface CreateSearchFormData {
  id?: number;
  name: string;
  description: string;
  hide_identity: boolean;
  check_description_status?: CheckDescriptionStatus;
  check_description_feedback?: string;
  filters: Partial<Record<keyof typeof SEARCH_FILTER_KEYS, SearchFilterForm>>;
  post_questions: Array<{ value: string }>;
  review_status?: string;
  extended: boolean;
  expiration_method: 'manually_archive' | 'date';
  expires_at: string;
  prompt_history_id?: number;
}

export interface EditSearchData extends CreateSearchFormData {
  id: number;
}

export interface CreateSearchFormProps {
  formData: CreateSearchFormData;
}

export type FilterPost = {
  filter: number;
  data:
    | { filter_value: string | number; filter_units?: string }
    | { filter_value: boolean; filter_units?: string }
    | { filter_value: Array<string | number>; filter_units?: string }
    | { filter_value: ExcludeDataVendorFilterForm; filter_units?: string };
};

export const getInitialFormState = (): CreateSearchFormData => {
  return {
    name: '',
    description: '',
    hide_identity: false,
    check_description_status: undefined,
    check_description_feedback: undefined,
    prompt_history_id: undefined,
    filters: {
      data_lag: {
        unit: 'Weeks',
        value: '',
      },
      price: {
        unit: 'USD',
        value: '',
      },
      history: {
        unit: 'Months',
        value: '',
      },
    },
    post_questions: [{ value: '' }],
    extended: false,
    expiration_method: 'manually_archive',
    expires_at: '',
  };
};
